import React, { useState, useRef, useEffect } from 'react';
import './CategoryTab.css';

const CategoryTab = ({ activeCategory, setActiveCategory, activeSubCategory, setActiveSubCategory }) => {
  const [isWebAppDropdownOpen, setIsWebAppDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const categories = [
    { id: 'All', label: 'All' },
    { id: 'Web Application', label: 'Web Application', hasDropdown: true },
    { id: 'Mobile Application', label: 'Mobile Application' },
    { id: 'AI / IoT / Analytics', label: 'AI / IoT / Analytics' },
    { id: 'Graphic Design', label: 'Graphic Design' },
  ];

  const subCategories = [
    { id: 'Ecommerce', label: 'Ecommerce' },
    { id: 'Portfolio', label: 'Portfolio' }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsWebAppDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleCategoryClick = (category) => {
    if (category.id === 'Web Application') {
      setIsWebAppDropdownOpen(!isWebAppDropdownOpen);
      if (activeCategory !== 'Web Application') {
        setActiveCategory('Web Application');
        setActiveSubCategory('All'); // Default when switching to Web App
      }
    } else {
      setActiveCategory(category.id);
      setActiveSubCategory(null);
      setIsWebAppDropdownOpen(false);
    }
  };

  const handleSubCategoryClick = (subCategory, e) => {
    e.stopPropagation();
    setActiveSubCategory(subCategory.id);
    setActiveCategory('Web Application');
    setIsWebAppDropdownOpen(false);
  };

  return (
    <div className="category-tab-container">
      <div className="category-tabs-wrapper">
        {categories.map((cat) => (
          <div 
            key={cat.id} 
            className={`category-tab-item ${activeCategory === cat.id ? 'cat-active' : ''}`}
            onClick={() => handleCategoryClick(cat)}
            ref={cat.hasDropdown ? dropdownRef : null}
          >
            <span>{cat.label}</span>
            {cat.hasDropdown && (
              <i className={`ri-arrow-${isWebAppDropdownOpen ? 'up' : 'down'}-s-line dropdown-icon`}></i>
            )}
            
            {cat.hasDropdown && isWebAppDropdownOpen && (
              <div className="category-dropdown-menu">
                {subCategories.map((subCat) => (
                  <div 
                    key={subCat.id}
                    className={`dropdown-menu-item ${activeSubCategory === subCat.id ? 'cat-active-sub' : ''}`}
                    onClick={(e) => handleSubCategoryClick(subCat, e)}
                  >
                    {subCat.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryTab;
